<script>
import itineraryService from '../../services/itinerary-service';

export default {
  name: 'ItineraryDayProgramDeleteModal',
  props: {
    itineraryId: {
      type: Number,
      required: true,
    },
    dayProgramEntryId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      toggled: true,
      loading: true,
      error: false,
      priceIntervals: null,
    };
  },
  created() {
    itineraryService.getPriceIntervalsByDayProgramEntryId({
      itineraryId: this.itineraryId,
      dayProgramEntryId: this.dayProgramEntryId,
    }).then((res) => {
      this.priceIntervals = res.data.priceIntervals;
      this.loading = false;
    }).catch(() => {
      this.loading = false;
      this.error = true;
    });
  },
  watch: {
    toggled(value) {
      if (!value) {
        this.$emit('close');
      }
    },
  },
};
</script>

<template>
  <v-dialog
    v-model="toggled"
    max-width="800px"
  >
    <v-card>
      <v-container v-if="!loading && priceIntervals">
        <v-flex font-weight-bold pa-3 title>
          Warning
        </v-flex>
        <v-flex pa-3>
          By deleting this day program entry you affect
          <b>{{ priceIntervals.length }}</b> future active price intervals.
        </v-flex>
        <v-flex
          v-for="(priceInterval, index) in priceIntervals"
          :key="`price-interval-${index}`"
          pl-3
        >
          {{ `Booking (from/to): ${priceInterval.book_from} / ${priceInterval.book_to}` }}
        </v-flex>
        <v-flex v-if="priceIntervals.length" pl-3 pt-3 class="red--text">
          Remember to re-calculate their prices.
        </v-flex>
      </v-container>
      <v-container v-else-if="error">
        <v-flex pa-3>
          An error occured. Contact IT.
        </v-flex>
      </v-container>
      <v-container v-else>
        <v-layout justify-center>
          <v-progress-circular indeterminate />
        </v-layout>
      </v-container>
      <v-divider light/>
      <v-layout justify-end>
        <v-btn
          color="blue darken-1"
          flat
          @click="$emit('close')"
        >
          Cancel
        </v-btn>
        <v-btn
          :disabled="loading || error && !priceIntervals"
          color="red darken-1"
          flat
          @click="$emit('deleteDayProgramEntry', {
            itineraryId,
            dayProgramId: dayProgramEntryId
          })"
        >
          Delete
        </v-btn>
      </v-layout>
    </v-card>
  </v-dialog>
</template>



// WEBPACK FOOTER //
// src/components/itinerary/ItineraryDayProgramDeleteModal.vue